import React, {forwardRef, MouseEventHandler, ReactNode} from "react";
import styled from "styled-components";

const StyledProgressBar = styled.div`
    border-radius: 5px;
    top: 22px;
    height: 16px;
    display: inline-block;
    position: absolute;
    left: 100px;
    right: 150px;
    background: #6D6D6D;
    .playbar {
        border-radius: 5px;
        position: relative;
        background:white;
        width: ${(props) => (props as any)['data-percentage']}%;
        
        height:100%;
        transition:all 100ms linear;
        // animation: play ${(props) => (props as any)['data-duration']}s linear;
        animation-play-state: ${(props) => (props as any)['data-play']};
        animation-delay:-${(props) => (props as any)['data-seek-time']}s;    
        &.stop {
            animation: none;
        }
    }
    @keyframes play {
        0% {width: 0%};
        100% {width: 100%};
    }
`;

interface IVideoProgressBar {
    className?: string,
    percentage: number,
    duration: number,
    isPlaying: boolean,
    onClick: MouseEventHandler<HTMLDivElement>,
    children?: ReactNode
}

const VideoProgressBar = forwardRef<HTMLDivElement, IVideoProgressBar>(({
                                                                            className,
                                                                            percentage,
                                                                            duration,
                                                                            isPlaying,
                                                                            onClick,
                                                                            children
                                                                        }, ref) => {
    return (
        <StyledProgressBar ref={ref}
                           data-percentage={percentage}
                           data-duration={duration}
                           data-play={isPlaying}
                           onClick={onClick}>
            <div className='playbar'></div>
            {children}
        </StyledProgressBar>
    )
});

export default VideoProgressBar;